class EdakkalSlot {
    constructor(name, isAvailable, adultPrice, childPrice, videoCameraPrice, slotsLeft, time, totalSlots, startTime, endTime) {
        this.name = name;
        this.isAvailable = isAvailable;
        this.adultPrice = adultPrice;
        this.childPrice = childPrice;
        this.videoCameraPrice = videoCameraPrice;
        this.slotsLeft = slotsLeft;
        this.time = time;
        this.totalSlots = totalSlots;
        this.startTime = startTime;
        this.endTime = endTime;
    }

    static fromJson(json) {
        return new EdakkalSlot(
            json.name,
            json.isAvailable,
            json.adultPrice,
            json.childPrice,
            json.videoCameraPrice,
            json.slotsLeft,
            json.time,
            json.totalSlots,
            json.startTime,
            json.endTime,
        );
    }

    toJson() {
        return {
            name: this.name,
            isAvailable: this.isAvailable,
            adultPrice: this.adultPrice,
            childPrice: this.childPrice,
            videoCameraPrice: this.videoCameraPrice,
            slotsLeft: this.slotsLeft,
            time: this.time,
            totalSlots: this.totalSlots,
            startTime: this.startTime,
            endTime: this.endTime,
        };
    }

    static get defaultEarlyBird() {
        return new EdakkalSlot(
            "Early Bird",
            true,
            100.00,
            50.00,
            1000.00,
            200,
            "7:00 AM - 8:30 AM",
            200,
            7 * 60, // 7:00 AM
            8 * 60 + 30, // 8:30 AM
        )
    }

    static get defaultMorning() {
        return new EdakkalSlot(
            "Morning",
            true,
            50.00,
            30.00,
            1000.00,
            400,
            "9:00 AM - 12:00 PM",
            400,
            9 * 60, // 9:00 AM
            12 * 60, // 12:00 PM
        )
    }

    static get defaultAfternoon() {
        return new EdakkalSlot(
            "Afternoon",
            true,
            50.00,
            30.00,
            1000.00,
            400,
            "12:30 AM - 3:30 PM",
            400,
            12 * 60 + 30, // 12:30 PM
            15 * 60 + 30, // 3:30 PM
        )
    }

}

export default EdakkalSlot;